import * as React from 'react'
import { css, useDramaticallyInefficientGlobalCss } from '@owl-nest/yak/extra-runtime'
import * as breakpoint from './constants/breakpoints'
import * as color from './constants/colors'
import * as font from './constants/fonts'

export const theme = {}

function useLockScrollGlobalStyle() {
  useDramaticallyInefficientGlobalCss(css`
    @media not screen and ${breakpoint.TABLET} {
      .lock-scroll {
        position: absolute;
        overflow-y: hidden;
      }
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    @media screen and ${breakpoint.TABLET} {
      .lock-scroll {
        top: initial;
        position: fixed;
        overflow-y: scroll;
      }
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    .lock-scroll {
      width: 100%;
    }
  `)
}

export function LockScrollGlobalStyle() {
  useLockScrollGlobalStyle()

  return <></>
}

export function GlobalStyleDesignSystem() {
  useLockScrollGlobalStyle()

  useDramaticallyInefficientGlobalCss(css`
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    html {
      line-height: 1.375;
      -webkit-text-size-adjust: 100%;
      scroll-behavior: smooth;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    body {
      background-color: ${color.PRIMARY_GREY_000};
      color: ${color.PRIMARY_GREY_900};
      font-family: ${font.PRIMARY_FONT};
      margin: 0;
      overflow-x: hidden;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    abbr[title] {
      -webkit-text-decoration: underline dotted;
      text-decoration: underline dotted;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    b,
    strong {
      font-weight: bolder;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    small {
      font-size: 80%;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    sub,
    sup {
      font-size: 75%;
      line-height: 0;
      position: relative;
      vertical-align: baseline;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    sub {
      bottom: -0.25em;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    sup {
      top: -0.5em;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    table {
      text-indent: 0;
      border-color: inherit;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    button,
    input,
    optgroup,
    select,
    textarea {
      font-family: inherit;
      font-size: 100%;
      line-height: 1;
      margin: 0;
      color: inherit;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    button,
    select {
      text-transform: none;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    button,
    [type='button'],
    [type='reset'],
    [type='submit'] {
      -webkit-appearance: button;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    ::-moz-focus-inner {
      border-style: none;
      padding: 0;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    :-moz-focusring {
      outline: 1px dotted ButtonText;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    :-moz-ui-invalid {
      box-shadow: none;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    legend {
      padding: 0;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    progress {
      vertical-align: baseline;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    [type='search'] {
      -webkit-appearance: textfield;
      outline-offset: -2px;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    ::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
      height: auto;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    ::-webkit-search-cancel-button,
    ::-webkit-search-decoration,
    ::-webkit-search-results-button,
    ::-webkit-search-results-decoration {
      -webkit-appearance: none;
      display: none;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    ::-webkit-file-upload-button {
      -webkit-appearance: button;
      font: inherit;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    blockquote,
    dl,
    dd,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    hr,
    figure,
    p,
    pre {
      margin: 0;
      font-weight: normal;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    button {
      background-color: transparent;
      background-image: none;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    button:focus {
      outline: 1px dotted;
      outline: 5px auto -webkit-focus-ring-color;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    fieldset {
      margin: 0;
      padding: 0;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    textarea {
      resize: vertical;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    ol,
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    a {
      color: inherit;
      text-decoration: inherit;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    img,
    svg,
    video,
    canvas,
    audio,
    iframe,
    embed,
    object {
      display: block;
      vertical-align: middle;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    img,
    video {
      max-width: 100%;
      height: auto;
    }
  `)

  /*
   * Use for sticky footer
   */
  useDramaticallyInefficientGlobalCss(css`
    #__next {
      height: 100%;
    }
  `)

  /*
   * Use for lock the scroll of the page to facilitate mobile navigation
   */
  useDramaticallyInefficientGlobalCss(css`
    .mobile-drawer-open {
      overflow-y: hidden;
      width: 100%;
    }
  `)

  useDramaticallyInefficientGlobalCss(css`
    @media screen and ${breakpoint.TABLET} {
      .mobile-drawer-open {
        overflow-x: hidden;
        overflow-y: scroll;
      }
    }
  `)

  return <></>
}
